import cn from 'classnames'
import React from 'react'

import './coreStepper.scss'
import { isValidArray } from 'mmfintech-commons'

interface IStepperProps {
  steps: string[]
  currentStep: number
}

const PROGRESS_WIDTH = 97 // use 97% of the width so it fits between the labels

const ProgressBar = ({ progress }: { progress: number }) => {
  return (
    <>
      <div className={cn('progress-bar-background', {})}></div>
      <div
        style={{ width: `${progress}%` }}
        className={cn('progress-bar-filled', {
          completed: PROGRESS_WIDTH === progress
        })}
      ></div>
    </>
  )
}

const Step = ({ currentStep, step, lastStep }: { currentStep: number; step: number; lastStep: number }) => {
  return (
    <div
      className={cn('step-wrapper', {
        'in-progress': step < currentStep,
        active: lastStep - 1 === currentStep
      })}
    >
      <span>{step}</span>
    </div>
  )
}

export const CoreStepper = ({ steps, currentStep }: IStepperProps) =>
  isValidArray(steps) ? (
    <div className='step-wrapper'>
      <span className='label'>{steps[currentStep]}</span>

      <div className='stepper-container'>
        {steps.map((step, index) => {
          if (index < currentStep - 1 || index > currentStep) return null
          return (
            <React.Fragment key={`${step}_${index}`}>
              <div className='step-container'>
                <Step currentStep={currentStep} step={index} lastStep={steps.length} />
              </div>
              {currentStep === 0 && (
                <div className='step-container'>
                  <Step currentStep={currentStep} step={currentStep + 1} lastStep={steps.length} />
                </div>
              )}
            </React.Fragment>
          )
        })}
        <ProgressBar progress={progress(steps.length - 1, currentStep)} />
      </div>
    </div>
  ) : null

const progress = (totalSteps: number, currentStep: number) => {
  const halfStep = PROGRESS_WIDTH / (totalSteps - 1) / 2

  if (currentStep >= totalSteps) return PROGRESS_WIDTH
  if (currentStep > 0) {
    if (currentStep === 1) {
      return halfStep
    }
    return ((currentStep - 1) * PROGRESS_WIDTH) / (totalSteps - 1) + halfStep
  }
  return 0
}
